module.exports = __webpack_public_path__ + "img/zsysjwl.8c9953b5.png";